module.exports = __webpack_public_path__ + "static/img/cont56 (1).6c28f37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont56 (1).jpg
// module id = 3gIT
// module chunks = 0